import React, { useContext, useState } from "react";
import { FiSend } from "react-icons/fi";
import { Spring, animated } from "react-spring";
import { AppContext } from "../../context/AppContext";
import useSound from "use-sound";
import soundOne from "../../assets/sounds/soundOne.wav";

const InputName = () => {
  const [userInfo, setUserInfo] = useContext(AppContext);
  const [name, setName] = useState({ name: null });

  const [play] = useSound(soundOne);

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserInfo({
      ...userInfo,
      name: name.name,
      progress: "13",
      currentKey: "name",
    });
  };

  const onChange = (e) => {
    setName({ ...name, [e.target.name]: e.target.value });
  };

  return (
    <Spring
      from={{ opacity: 0, marginBottom: -500 }}
      to={{ opacity: 1, marginBottom: 0 }}
    >
      {(styles) => (
        <animated.div style={styles}>
          <div className="shadow-2xl p-6 md:p-10 rounded-lg bg-white m-4 transform hover:scale-105 transition duration-200 ease-in-out">
            <div className="text-xl">Let’s start with your name. </div>
            <form className="flex" onSubmit={handleSubmit}>
              <input
                name="name"
                className="m-2 text-center md:text-left w-full border-b-2 border-blue-300 text-lg"
                type="text"
                placeholder="Enter your name here..."
                required
                onChange={onChange}
                maxLength="30"
              ></input>
              <button
                type="submit"
                className="self-center flex items-center justify-center rounded-full h-10 w-11 cursor-pointer transition duration-200 ease-in-out bg-blue-600 hover:bg-blue-800 transform hover:-translate-y-1 hover:scale-110"
                onClick={play}
              >
                <FiSend className="" size="24" color="white" />
              </button>
            </form>
          </div>
        </animated.div>
      )}
    </Spring>
  );
};

export default InputName;
